export default __webpack_public_path__ + "static/media/Ericsson.f3cae807.png";